<template>
  <div class="h-auto w-full mr-3">
    <div class="bg-white mx-3 rounded-b-md">
      <div class="border-b-0.5 flex justify-between items-center p-3">
        <p class="text-sm font-semibold w-full">List of Employment Types</p>
      </div>
      <div class="flex justify-between items-center">
        <el-pagination
          background
          @size-change="handleSizeChange"
          :page-sizes="pageSizes"
          :page-index="pageIndex"
          :page-size="pageSize"
          layout="sizes"
          :total="currentTableData.length"
        >
        </el-pagination>
        <!-- search -->
        <input
          v-model="searchInput"
          type="search"
          placeholder="Start typing to search..."
          class="p-2 bg-gray-200 w-52 m-2 py-1 rounded-md"
        />
        <!-- search -->
        <div class="flex flex-wrap justify-end w-full gap-3">
          <button
            @click="showCreateEmploymentType = true"
            class="border-1.5 rounded-full px-1 py-1 items-center bg-primaryDark hover:bg-primary hover:text-gray-200 text-white border-primary flex gap-1 capitalize"
          >
            <svg
              id="Layer_1"
              height="20"
              viewBox="0 0 24 24"
              width="20"
              xmlns="http://www.w3.org/2000/svg"
              data-name="Layer 1"
              fill="#fff"
            >
              <path
                d="m12 0a12 12 0 1 0 12 12 12.013 12.013 0 0 0 -12-12zm4 13h-3v3a1 1 0 0 1 -2 0v-3h-3a1 1 0 0 1 0-2h3v-3a1 1 0 0 1 2 0v3h3a1 1 0 0 1 0 2z"
              />
            </svg>
            Create
          </button>
        </div>
      </div>

      <div class="px-2 pb-2 relative">
        <transition name="fade">
          <div v-if="loading" class="inset-0 absolute z-50 bg-white w-full">
            <loader class="center-h-v" />
          </div>
        </transition>

        <transition name="fade">
          <div
            v-if="del_error"
            class="p-1 text-center text-sm w-full bg-yellow-200"
          >
            {{ del_error }}
          </div>
        </transition>
        <transition name="fade">
          <div
            v-if="showLocCrSuccess"
            class="p-1 text-center text-sm w-full bg-green-200"
          >
            {{ create_success }}
          </div>
        </transition>
        <transition name="fade">
          <div
            v-if="showAddEmploymentTypeSuccess"
            class="p-1 text-center text-sm w-full bg-green-200"
          >
            {{ add_dept_success }}
          </div>
        </transition>
        <transition name="fade">
          <div
            v-if="showLocDelSuccess"
            class="p-1 text-center text-sm w-full bg-green-200"
          >
            {{ showLocDelSuccess }}
          </div>
        </transition>

        <div>
          <ve-table
            v-if="searchInput"
            :columns="columns"
            :table-data="filteredTableData"
            sort-order="asc"
          />

          <ve-table
            :columns="columns"
            :tableData="tableData"
            v-if="!searchInput.length"
          >
          </ve-table>

          <p
            v-if="searchInput.length && filteredTableData.length === 0"
            class="text-center py-3"
          >
            No results
          </p>

          <p
            v-if="tableData.length == 0 && !loading && !get_error"
            class="p-1 text-center text-sm w-full bg-gray-100"
          >
            No Employment Types found
          </p>
          <!-- Pagination -->
          <div class="table-pagination text-center mt-2">
            <!-- <ve-pagination :total="totalCount" :page-index="pageIndex" :page-size="pageSize"
              @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" :show-jumper="false" /> -->
            <el-pagination
              background
              layout="prev, pager, next"
              :total="totalCount"
              :page-size="pageSize"
              @current-change="handleCurrentChange"
            >
              <!-- :current-page.sync="currentPage4" -->
            </el-pagination>
          </div>
          <!-- Pagination -->
        </div>
        <transition name="fade">
          <div
            v-if="get_error"
            class="p-1 text-center text-sm w-full bg-yellow-200"
          >
            {{ get_error }}
          </div>
        </transition>
      </div>
    </div>
    <!-- create -->
    <CreateEmploymentType
      @close="handleClose"
      :showCreateEmploymentType="showCreateEmploymentType"
      @closeOnSuccess="handleCloseOnSuccess"
    >
    </CreateEmploymentType>

    <AddEmploymentType
      @close="handleClose"
      :showAddEmploymentType="showAddEmploymentType"
      :selectedRow="selectedRow"
      @closeOnSuccess="handleCloseOnAddDept"
    ></AddEmploymentType>

    <EditEmploymentType
      @close="handleClose"
      :showEditEmploymentType="showEditEmploymentType"
      :employmentTypeToEdit="employmentTypeToEdit"
      @closeOnSuccess="handleCloseOnAddDept"
      :reload="reload"
    >
    </EditEmploymentType>
    <BulkUpload
      v-if="showBulkUpload"
      :close="close"
      :showBulkUpload="showBulkUpload"
      :showBulkUploadCallback="showBulkUploadCallback"
      :title="title"
      dataType="Employment Type"
      :url="url"
      :dataColumns="[]"
      :columns="resultColumns"
    ></BulkUpload>
    <action-warning
      :message="message"
      :set-is-confirmed="setIsConfirmed"
      :show-warning="showWarning"
      @close="showWarning = false"
      :title="title"
    ></action-warning>
    <BulkUploadAssets
      :show-asset-bulk-upload="showAssetBulkUpload"
      v-if="showAssetBulkUpload"
      @close="showAssetBulkUpload = false"
      :reload="reload"
    ></BulkUploadAssets>
  </div>
</template>

<script>
import BulkUploadAssets from "@/components/employees/modals/bulkUploadAssets.vue";
import axios from "axios";
import Loader from "@/components/loader/loader.vue";
import { mapGetters } from "vuex";
//import { utils, writeFileXLSX } from "xlsx";
import ActionWarning from "../../../utils/actionWarning.vue";
import { importTemplateGenerator } from "@/utils/importTemplateGenerator";
// import { createPopper } from '@popperjs/core';

export default {
  name: "employmentTypesList",
  components: {
    Loader,
    BulkUploadAssets,
    BulkUpload: () => import("@/utils/bulkUploadsUtils.vue"),
    CreateEmploymentType: () =>
      import("@/components/CompanySetups/employmentTypes/create.vue"),
    AddEmploymentType: () =>
      import(
        "@/components/CompanySetups/employmentTypes/addEmploymentTypes.vue"
      ),
    EditEmploymentType: () =>
      import(
        "@/components/CompanySetups/employmentTypes/editEmploymentTypes.vue"
      ),
    ActionWarning,
  },
  data() {
    return {
      url: "",
      showBulkUpload: false,
      resultColumns: [],
      showAssetBulkUpload: false,
      showCreateEmploymentType: false,
      showAddEmploymentType: false,
      loading: false,
      get_error: null,
      linemanagers: [],
      filteredTabs: [],
      departments: [],
      selectedRow: null,
      // page index
      pageIndex: 1,
      // page size
      pageSize: 10,
      pageSizes: [],
      employmentTypeDetails: null,
      searchInput: "",
      message: null,
      title: "Employment Type",
      showWarning: false,
      departmentToDelete: null,
      employmentTypeToEdit: {
        Id: "",
        Name: "",
      },

      showEditEmploymentType: false,
      create_success: "Emplyment Type created successfully",
      del_loca: "Emplyment Type  deleted successfully",
      add_dept_success: "Emplyment Type have been added successfully",
      del_error: null,
      showLocCrSuccess: false,
      showAddEmploymentTypeSuccess: false,
      showLocDelSuccess: null,
      saved_departments: null,

      columns: [
        {
          field: "",
          key: "numbering",
          title: "#",
          width: 10,

          align: "center",
          renderBodyCell: ({ rowIndex }) => {
            return ++rowIndex;
          },
        },

        {
          field: "Name",
          key: "a",
          title: "Employment Type Name",
          headerAlign: "left",
          align: "left",
          sampleValue: "Contract",
        },

        // {
        //   field: "Description",
        //   key: "b",
        //   title: "Description",
        //   headerAlign: "left",
        //   align: "left",
        //   sampleValue: "Temporary Employee for a Defined Period",
        // },

        {
          title: "Action",
          field: "",
          key: "action",
          renderBodyCell: ({ row }) => (
            <ve-popper
              trigger="clickToOpen"
              options={{
                placement: "top",
                modifiers: { offset: { offset: "0,10px" } },
              }}
            >
              <div class="bg-white p-2 shadow-md popper">
                <button
                  class="w-full text-left py-1 px-2 hover:bg-primary hover:text-white"
                  style="boder-radius: 0 !important"
                  onClick={() => this.handleEditButtonClick(row)}
                >
                  Edit
                </button>
                <button
                  class="w-full text-left py-1 px-2 hover:bg-primary hover:text-white"
                  style="boder-radius: 0 !important"
                  onClick={() => this.handleDeleteButtonClick(row)}
                >
                  Delete
                </button>
              </div>

              <button slot="reference">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  id="Outline"
                  viewBox="0 0 24 24"
                  width="20"
                  height="20"
                >
                  <circle cx="12" cy="2" r="2" />
                  <circle cx="12" cy="12" r="2" />
                  <circle cx="12" cy="22" r="2" />
                </svg>
              </button>
            </ve-popper>
          ),
        },
      ],
      tableData: [],
    };
  },
  computed: {
    ...mapGetters(["getOrganization", "getToken"]),
    filteredTableData() {
      if (!this.searchInput) {
        // If no search input is provided, return the full tableData
        return this.tableData;
      } else {
        // Filter the tableData based on the search input
        const searchInputLower = this.searchInput.toLowerCase();
        return this.tableData.filter((item) => {
          // Loop through each item's properties and check if they contain the search input
          for (let key in item) {
            if (
              item[key]?.toString().toLowerCase().includes(searchInputLower)
            ) {
              return true;
            }
          }
          return false;
        });
      }
    },
    // table data
    currentTableData() {
      const { pageIndex, pageSize } = this;
      return this.tableData.slice(
        (pageIndex - 1) * pageSize,
        pageIndex * pageSize
      );
    },
    // total count
    totalCount() {
      return this.tableData.length;
    },
  },
  created() {
    this.getDepartments();
    this.setPageSizes();
  },

  methods: {
    close() {
      this.$emit("close");
      this.showBulkUpload = false;
    },
    reload() {
      this.getDepartments();
      setTimeout(() => {
        this.showAssetBulkUpload = false;
      }, 3000);
    },
    showBulkUploadForm() {
      this.resultColumns = this.columns.filter((col) => col.title !== "Action");
      this.showBulkUpload = true;
    },
    showBulkUploadCallback() {
      this.showBulkUpload = false;
    },
    setIsConfirmed() {
      this.showWarning = false;
      this.deleteEmployementType(this.departmentToDelete);
    },
    handleSizeChange(newPageSize) {
      this.pageSize = newPageSize;
    },
    handleCurrentChange(currentPage) {
      this.pageIndex = currentPage;
    },
    setPageSizes() {
      // Generate the page sizes array using a loop
      for (let i = 1; i <= 10; i++) {
        this.pageSizes.push(this.pageSize * i);
      }
    },
    // page number change
    pageNumberChange(pageIndex) {
      this.pageIndex = pageIndex;
    },

    // page size change
    pageSizeChange(pageSize) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
    },
    handleEditButtonClick(employmentType) {
      // Handle the button click for the edit button
      //console.log(employmentType);
      this.employmentTypeToEdit = {
        EmploymentTypeId: employmentType.Id,
        Name: employmentType.Name,
        Description: employmentType.Description
          ? employmentType.Description
          : "",
      };
      this.showEditEmploymentType = true;
    },
    handleDeleteButtonClick(employementType) {
      // Handle the button click for the delete button
      //console.log(employementType)
      this.title = `Delete ${employementType.Name}`;
      this.message = `You are about to delete ${employementType.Name}!`;
      this.departmentToDelete = employementType;
      this.showWarning = true;
    },
    handleClose() {
      this.showCreateEmploymentType = false;
      this.showEditEmploymentType = false;
    },
    handleCloseOnSuccess() {
      this.showCreateEmploymentType = false;
      this.showLocCrSuccess = true;
      setTimeout(() => {
        this.showLocCrSuccess = false;
      }, 3000);
      this.getDepartments();
    },

    handleDeleteOnSuccess() {
      setTimeout(() => {
        this.showLocDelSuccess = null;
      }, 3000);
      this.getDepartments();
    },

    AddEmploymentType(row) {
      this.selectedRow = row;
      this.showAddEmploymentType = true;
    },

    handleCloseOnAddDept() {
      this.showAddEmploymentType = false;
      this.showAddEmploymentTypeSuccess = true;
      setTimeout(() => {
        this.showAddEmploymentTypeSuccess = false;
      }, 3000);
    },

    // /{organization}/setup/employementtype/v1/request
    getDepartments() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/setup/employementtype/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              //console.log(response.data.Data);
              this.tableData = response.data.Data;
              this.departments = response.data.Data;
              // this.tableData.forEach((v, index) => {
              //   v.rowKey = `${index + ``}`;
              //   v.departments = [];
              // });
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
        );
    },

    // /{organization}/setup/employment/type/{employmentTypeId}/v1/delete
    deleteEmployementType(employementType) {
      //console.log(employementType)
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .delete(
          `${this.getOrganization}/setup/employment/type/${employementType.Id}/${this.$ApiVersion}/delete`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.showLocDelSuccess = response.data.StatusMessage;
              this.handleDeleteOnSuccess();
            } else {
              this.del_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;

            this.del_error = error.message;
            setTimeout(() => {
              this.del_error = null;
            }, 2500);
          }
        );
    },
    exportTemplate() {
      this.filteredTabs = this.columns.filter(
        (column) => column.title !== "Action"
      );
      JSON.stringify(this.filteredTabs);
      importTemplateGenerator(
        this.filteredTabs,

        "Employment Type"
      );
    },
  },
};
</script>

<style>
.custom-menu {
  display: block;
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 10;
  min-width: 120px;
  padding: 0.5rem 0;
  margin: 0;
  list-style: none;
  background-color: #fff;
  border: 1px solid #ccc;
  box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.15);
}
</style>
